import { auth } from "../firebase";

const BASE = (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, "");

export function requiredAdminApiBase(value: string | undefined, production: boolean): string {
  const base = (value ?? "").replace(/\/$/, "");
  if (production && !base) throw new Error("Missing VITE_ADMIN_API_BASE_URL");
  return base;
}

const ADMIN_BASE = requiredAdminApiBase(import.meta.env.VITE_ADMIN_API_BASE_URL, import.meta.env.PROD);

export function apiUrl(path: string): string {
  return BASE + path;
}

export function adminApiUrl(path: string): string {
  return ADMIN_BASE + path;
}

export async function authedFetch(pathOrUrl: string, init: RequestInit = {}): Promise<Response> {
  const user = auth.currentUser;
  const headers = new Headers(init.headers);
  if (user) {
    const token = await user.getIdToken();
    headers.set("Authorization", `Bearer ${token}`);
  }
  const isDirect = /^https?:\/\//.test(pathOrUrl);
  const url = isDirect ? pathOrUrl : apiUrl(pathOrUrl);
  return fetch(url, { ...init, headers, credentials: isDirect ? "omit" : "include" });
}
